module.exports = __webpack_public_path__ + "static/vijay-a70766c80efc59374ac1617411e88807.jpg";